import { lazy } from 'react';

import { RouterSuspense } from '@/lib';

export const OrdersNewAsync = RouterSuspense(lazy(() => import('./index.tsx')));
